import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubscriptionCancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center px-4'>
      <div className='max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center'>
        {/* Cancel Icon */}
        <div className='w-16 h-16 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center'>
          <svg
            className='w-8 h-8 text-red-600'
            fill='currentColor'
            viewBox='0 0 20 20'
          >
            <path
              fillRule='evenodd'
              d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
              clipRule='evenodd'
            />
          </svg>
        </div>

        {/* Cancel Message */}
        <h1 className='text-2xl font-bold text-gray-900 mb-2'>
          Subscription Cancelled
        </h1>
        <p className='text-gray-600 mb-8'>
          No worries! Your subscription process was cancelled. You can always
          come back and subscribe later when you're ready.
        </p>

        {/* Action Buttons */}
        <div className='space-y-3'>
          <button
            onClick={() => navigate('/profile/subscription')}
            className='w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors'
          >
            View Pricing Again
          </button>
          <button
            onClick={() => navigate('/practice')}
            className='w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-medium hover:bg-gray-50 transition-colors'
          >
            Continue with Current Plan
          </button>
        </div>

        {/* Help Text */}
        <div className='mt-6 pt-6 border-t border-gray-200'>
          <p className='text-sm text-gray-500'>
            Need help choosing a plan?{' '}
            <button
              onClick={() => navigate('/pricing')}
              className='text-blue-600 hover:text-blue-700 underline'
            >
              Compare our plans
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
